import { render } from "./itemAd.vue?vue&type=template&id=69cf2358&scoped=true"
import script from "./itemAd.vue?vue&type=script&lang=js"
export * from "./itemAd.vue?vue&type=script&lang=js"

import "./itemAd.vue?vue&type=style&index=0&id=69cf2358&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cf2358"]])

export default __exports__